export function getLinkTargetUrl(node: Element | null, location = window.location) {
    if (!node) return null;

    const href = node.getAttribute('href');
    const origin = `${location.protocol}//${location.hostname}${
        location.port ? ':' + location.port : ''
    }`;

    if (href && !href.match(/^http/)) {
        return `${origin}${href}`;
    }

    return href;
}
export default getLinkTargetUrl;
